import { Component } from '@angular/core';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';
import swal from 'sweetalert2';
import { RepeaterComponent } from '../repeater/repeater.component';

@Component({
  selector: 'app-process-repeater',
  templateUrl: '../repeater/repeater.component.html',
  styleUrls: ['../repeater/repeater.component.scss'],
})
export class ProcessRepeaterComponent extends RepeaterComponent {
  get items(): AttributeModel[] {
    return super.items.filter(item => !this.isDeleted(item));
  }

  private isDeleted(item: AttributeModel): boolean {
    const deletedOption = item.options.find(
      opt => opt.key.toLowerCase() === 'deleted' && opt.value.toLowerCase() === 'true'
    );
    return !!deletedOption;
  }

  onRemove(index: number): void {
    if (!this.checkViewMode('edit')) {
      return;
    }

    swal
      .fire({
        title: 'Deseja excluir?',
        text: 'Esta ação não poderá ser desfeita.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
      })
      .then(result => {
        if (result.isConfirmed) {
          this.markAsDeleted(index);
          this.collapseMenuIndex = null;
        }
      });
  }

  private markAsDeleted(index: number): void {
    const item = super.items[index];
    const deletedOption = item.options.find(opt => opt.key.toLowerCase() === 'deleted');

    if (deletedOption) {
      deletedOption.value = 'true';
    } else {
      item.options.push({ key: 'deleted', value: 'true', type: 'Boolean' });
    }

    this.emit({ name: "autosave", data: "silently" });
  }
}